// extracted by mini-css-extract-plugin
module.exports = {"closedMessageBody":"_3V8rzO3MsloAkByuYXBnx4"};